// Module
var code = `<h1>Прямые переходы</h1> <h3 class="metric-meaning">Что значит?</h3><p>Визиты из закладок, браузерной строки, мессенджеров и т.д.</p> `;
// Exports
module.exports = code;